import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import { useAuth } from '../../../contexts/Auth';
import TitlePage from '../../../components/TitlePage';
import H1Styled from '../../../components/Typography/H1Styled';
import FiltersBar from '../../../components/Filters/FiltersBar';
import { FilterType } from '../../../interfaces/filters';
import Pagination from '../../../components/Pagination';
import { listSuspended } from '../../../api/payments';
import SuspendedPaymentsTable from '../Tables/SuspendedPaymentsTable';

const SuspendedPayments: React.FC = () => {
  const [{ token }] = useAuth();
  const [searchParams] = useSearchParams();

  const paymentsQuery = useQuery({
    queryKey: ['suspended-payments', searchParams.toString()],
    queryFn: () => listSuspended(searchParams, token),
  });

  return (
    <>
      <TitlePage title='Pagamenti sospesi' />

      <div className='col-span-12 lg:col-span-9 xl:col-span-10'>
        <div className='mt-12 space-y-4'>
          <H1Styled noMargin>Pagamenti sospesi</H1Styled>

          <FiltersBar
            filters={[
              {
                type: FilterType.DATE,
                label: 'Data pagamento',
                attribute: 'date',
                quickFilters: 'treasury',
              },
            ]}
          />

          <SuspendedPaymentsTable paymentsQuery={paymentsQuery} />

          {paymentsQuery.data && (
            <Pagination pagination={paymentsQuery.data?.meta?.pagination} />
          )}
        </div>
      </div>
    </>
  );
};

export default SuspendedPayments;
